<template>
  <ButtonBase
    :class="{ 'button-outline': !disabled, small: size === 'extra-small' || size === 'small' }"
    :buttonText="buttonText"
    :disabled="disabled"
    :iconLeft="iconLeft"
    :iconRight="iconRight"
    :size="size"
    @onClicked="onClicked"
  >
    <template #left>
      <slot name="left" />
    </template>
    <template #right>
      <slot name="right" />
    </template>
  </ButtonBase>
</template>

<script lang="ts" setup>
import ButtonBase from '@/design-system/atoms/buttons/ButtonBase.vue'
interface EMITS {
  (e: 'onClicked')
}
const props = withDefaults(
  defineProps<{
    buttonText?: string
    disabled?: boolean
    iconLeft?: string
    iconRight?: string
    size?: string
  }>(),
  {
    buttonText: '',
    disabled: false,
    iconLeft: '',
    iconRight: '',
    size: 'medium'
  }
)

const emits = defineEmits<EMITS>()

function onClicked() {
  if (!props.disabled) {
    emits('onClicked')
  }
}
</script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';
.button-outline {
  // Text
  color: variables.$color-primary;
  // Border
  border: 2px solid variables.$color-primary;
  // Outline
  outline: 5px solid transparent;
  outline-offset: -1pt;
  &:hover {
    outline: 4px solid variables.$color-primary;
  }
  &:focus {
    box-shadow: variables.$button-outline-focus;
    outline: 4px solid variables.$color-primary-light;
    outline-color: variables.$color-primary-light;
  }
  // Small
  &.small {
    border: 1px solid variables.$color-primary;
    outline: 2px solid transparent;
  }
  &.small:hover {
    outline: 2px solid variables.$color-primary;
  }
  &.small:focus {
    border: 1px solid variables.$color-primary;
    box-shadow: variables.$button-outline-focus-small;
    outline: 2px solid variables.$color-primary-light;
    outline-offset: unset;
  }
}
</style>
